import "core-js/modules/es.array.push.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
/* eslint-disable import/prefer-default-export */
import { storeToRefs } from 'pinia';
import { useUserStore } from '../store';

// 埋点
export function rlog(params, needSvip = false) {
  if (needSvip) {
    const {
      isSvip,
      isSlideVip,
      isVip
    } = storeToRefs(useUserStore());
    let vip = 'other';
    if (unref(isSvip)) {
      vip = 'svip';
    } else if (unref(isSlideVip)) {
      vip = 'pptvip';
    } else if (unref(isVip)) {
      vip = 'dictvip';
    }
    params.push(['vip', vip]);
  }
  window._rlog.push(['_trackCustom', 'event', params]);
}
export function downloadBlob(data, name) {
  const a = document.createElement('a');
  a.href = window.URL.createObjectURL(data);
  a.download = name; // 下载文件的名字
  document.body.appendChild(a);
  a.click();
}
export function getParameter(name) {
  const r = new RegExp(`(\\?|#|&)${name}=([^&#]*)(&|#|$)`);
  const m = window.location.href.match(r);
  return decodeURIComponent(!m ? '' : m[2]);
}